import { FunctionComponent } from "react";
import Select, { GroupBase, PropsValue, SingleValue } from "react-select";
import Label from "../../../Label";
import "./styles.scss";
import useDevice from "../../../../utils/hooks/useDevice";

type Props = {
  handleSelect: (
    option: SingleValue<{ value: string; label: string }>,
    e: any
  ) => void;
  placeholder: string;
  options: { value: string; label: string; isDisabled?: boolean }[];
  label: string;
  value: PropsValue<{
    value: any;
    label: string;
  }>;
  productConfig: string;
  isDisabled?: boolean;
};

const ConfigSelect: FunctionComponent<Props> = ({
  handleSelect,
  options,
  label,
  value,
  productConfig,
  isDisabled,
}) => {
  const { isMobile } = useDevice();

  return (
    <div className="config-select">
      <Label
        tag="label"
        style={{ color: "#666666", textAlign: "left", fontSize: "14px" }}
      >
        {label}
      </Label>
      <Select
        isSearchable={false}
        name={productConfig}
        id={productConfig}
        options={options}
        onChange={(value, event) => handleSelect(value, event)}
        placeholder={"prueba"}
        isDisabled={isDisabled}
        value={value}
        styles={{
          control: (base) => ({
            ...base,
            maxWidth: "429px",
            backgroundColor: "white",
            border: 0,
            boxShadow: "none",
            paddingLeft: ".5rem",
          }),
          valueContainer: (base) => ({
            ...base,
            height: "46px",
          }),
          singleValue: (base) => ({
            ...base,
            color: "#828282",
            textAlign: "left",
            fontSize: isMobile ? "14px" : "16px",
          }),
          option: (base, state) => ({
            ...base,
            cursor: "pointer",
            backgroundColor: state.isSelected ? "#EBEBEC" : "white",
            color: "#221F28",
            textAlign: "left",
            fontSize: isMobile ? "14px" : "16px",
            ":active": {
              backgroundColor: "white",
            },
          }),
          menu: (base) => ({
            ...base,

            maxWidth: "429px",
            cursor: "pointer",
          }),
        }}
      />
    </div>
  );
};

export default ConfigSelect;
